import {Component, Input} from '@angular/core';
import {Store} from "@ngrx/store";
import {GonvarriQuoteEditEntry} from "../../core/actions/gonvarri-quote-edit.entry";
import {StateWithMultiCart} from "@spartacus/cart/base/core";
import {GonvarriQuoteService} from "../../core/services/gonvarri-quote.service";

@Component({
  selector: 'app-gonvarri-product-quote-discount',
  standalone: false,
  templateUrl: './gonvarri-product-quote-discount.component.html',
  styleUrl: './gonvarri-product-quote-discount.component.scss'
})
export class GonvarriProductQuoteDiscountComponent {

  constructor(
    public quoteService: GonvarriQuoteService
  ) {}

  @Input() entryNumber!: number;
  @Input() quoteCode!: string;
  @Input() disableDiscountInput: boolean = false;
  @Input() quotePromotionNewPrice: number | undefined;

  editEntry(): void {
    this.quoteService.editQuoteDiscount(
      this.entryNumber,
      this.quoteCode,
      this.quotePromotionNewPrice!.toString().replaceAll(",", ".")
    );
  }

}
